import React from "react";
import styled from "styled-components";

const BrandBarContainer = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
color:white;
background: var(--primary-color);
justify-content: center;
position: sticky;
top: 0;
padding:0.5rem;
img
{
    width: auto;
}
`;

export default (props:{
    imgHeight?:string
    style?:React.CSSProperties
}) => {

    return (
        <BrandBarContainer style={props.style} >
            <img style={{height:props.imgHeight ?? '25px'}} src="/logotipo.png" />
        </BrandBarContainer>
    );
}